import {
  GET_GOALS,
  GET_GOALS_SUCCESS,
  GET_GOALS_ERROR,
  UPDATE_GOAL,
  UPDATE_FILTER_GOAL_VALUE,
  APPLY_FILTER_GOAL,
  UPDATE_GOAL_INACTIVE,
  Actions,
  UPDATE_FILTER_GOAL_INACTIVE,
  UPDATE_MISSING_SCHOOL_GOALS,
  SAVE_GOALS,
  SAVE_GOALS_SUCCESS,
  SAVE_GOALS_ERROR,
} from "./actions";
import { goalsState } from "./state";
import * as _ from "lodash";
import { school } from "../schools/state";

export const initialGoalsState = {
  originalData: {},
  updatedData: {},
  filterGoalValue: null,
  filterGoalInactive: null,
  pending: null,
  error: null,
  hasChangesToSave: false,
  goalsWithErrors: null,
  hasGoalErrors: false,
  hasSavedSuccessfully: null,
};

//remember to avoid mutation within reducers
export function goals(state = initialGoalsState, Actions): goalsState {
  switch (Actions.type) {
    case GET_GOALS:
      return Object.assign({}, state, {
        pending: true,
        error: null,
        hasSavedSuccessfully: null,
      });
    case GET_GOALS_SUCCESS:
      return Object.assign({}, state, {
        originalData: _.keyBy(Actions.payload, "entityId"),
        updatedData: _.keyBy(Actions.payload, "entityId"),
        pending: false,
        error: null,
        hasChangesToSave: false,
        goalsWithErrors: null,
        hasGoalErrors: false,
        filterGoalValue: undefined,
        filterGoalInactive: undefined,
      });
    case GET_GOALS_ERROR:
      return Object.assign({}, state, {
        pending: false,
        error:
          "There was an error in loading your goals! Please try again later.",
      });
    case UPDATE_GOAL:
      let updatedGoalData = {
        ...state.updatedData,
        [Actions.payload.id]: {
          ...state.updatedData[Actions.payload.id],
          goal: Actions.payload.value,
        },
      };
      let updatedGoalHasChangesToSave = !_.isEqual(
        state.originalData,
        updatedGoalData
      );
      let updatedGoalErrors = {
        ...state.goalsWithErrors,
        [Actions.payload.id]: {
          hasError:
            updatedGoalData[Actions.payload.id].goal == null &&
            !updatedGoalData[Actions.payload.id].inactive,
        },
      };
      let hasGoalErrors = _.some(updatedGoalErrors, (o) => o.hasError);
      return Object.assign({}, state, {
        updatedData: updatedGoalData,
        pending: false,
        hasChangesToSave: updatedGoalHasChangesToSave,
        goalsWithErrors: updatedGoalErrors,
        hasGoalErrors,
        hasSavedSuccessfully: null,
      });
    case UPDATE_FILTER_GOAL_VALUE:
      return Object.assign({}, state, {
        ...state,
        filterGoalValue: Actions.payload,
      });
    case APPLY_FILTER_GOAL:
      let newUpdatedData = _.cloneDeep(state.updatedData);
      _.forEach(Actions.payload.schools, (school: school) => {
        if (newUpdatedData[school.systemSchoolId]) {
          // if there's a goal for that school, update its goal value
          if (
            state.filterGoalValue === undefined &&
            state.filterGoalInactive === undefined &&
            Actions.payload.district &&
            Actions.payload.district.id
          ) {
            // if we haven't set a filter goal value yet, it uses the district goal value by default
            if (state.updatedData[Actions.payload.district.id].inactive) {
              newUpdatedData[school.systemSchoolId] = {
                ...newUpdatedData[school.systemSchoolId],
                inactive:
                  state.updatedData[Actions.payload.district.id].inactive,
              };
            } else {
              newUpdatedData[school.systemSchoolId] = {
                ...newUpdatedData[school.systemSchoolId],
                goal: state.updatedData[Actions.payload.district.id].goal,
              };
            }
          } else if (state.filterGoalInactive) {
            newUpdatedData[school.systemSchoolId] = {
              ...newUpdatedData[school.systemSchoolId],
              inactive: state.filterGoalInactive,
            };
          } else {
            newUpdatedData[school.systemSchoolId] = {
              ...newUpdatedData[school.systemSchoolId],
              goal: state.filterGoalValue,
              inactive: state.filterGoalInactive,
            };
          }
        }
      });
      if (Actions.payload.selectedSchoolLevel == "All") {
        // if applying to All, also change the district value
        if (
          state.filterGoalValue !== undefined ||
          state.filterGoalInactive !== undefined
        ) {
          // if we haven't set a filter goal value yet, it uses the district goal value by default (so we don't need to reset it)
          if (state.filterGoalInactive) {
            newUpdatedData[Actions.payload.district.id] = {
              ...newUpdatedData[Actions.payload.district.id],
              inactive: state.filterGoalInactive,
            };
          } else {
            newUpdatedData[Actions.payload.district.id] = {
              ...newUpdatedData[Actions.payload.district.id],
              goal: state.filterGoalValue,
              inactive: state.filterGoalInactive,
            };
          }
        }
      }
      let hasChangesAfterApplyingFilter = !_.isEqual(
        state.originalData,
        newUpdatedData
      );
      return Object.assign({}, state, {
        ...state,
        updatedData: newUpdatedData,
        hasChangesToSave: hasChangesAfterApplyingFilter,
        hasSavedSuccessfully: null,
      });
    case UPDATE_GOAL_INACTIVE:
      let newUpdatedInactiveData = {
        ...state.updatedData,
        [Actions.payload.id]: {
          ...state.updatedData[Actions.payload.id],
          inactive: Actions.payload.value,
        },
      };
      let updatedHasChangesToSave = !_.isEqual(
        state.originalData,
        newUpdatedInactiveData
      );
      let updatedGoalInactiveErrors = {
        ...state.goalsWithErrors,
        [Actions.payload.id]: {
          hasError:
            newUpdatedInactiveData[Actions.payload.id].goal == null &&
            !newUpdatedInactiveData[Actions.payload.id].inactive,
        },
      };
      let hasGoalInactiveErrors = _.some(
        updatedGoalInactiveErrors,
        (o) => o.hasError
      );
      return Object.assign({}, state, {
        updatedData: newUpdatedInactiveData,
        pending: false,
        hasChangesToSave: updatedHasChangesToSave,
        goalsWithErrors: updatedGoalInactiveErrors,
        hasGoalErrors: hasGoalInactiveErrors,
        hasSavedSuccessfully: null,
      });
    case UPDATE_FILTER_GOAL_INACTIVE:
      return Object.assign({}, state, {
        ...state,
        filterGoalInactive: Actions.payload.value,
      });
    case UPDATE_MISSING_SCHOOL_GOALS:
      let newGoalsObj = {};
      _.forEach(Actions.payload.schoolIds, (missingSchoolId) => {
        newGoalsObj[missingSchoolId] = {
          customerId: Actions.payload.districtId,
          entityLevel: "school",
          entityId: missingSchoolId,
          goal: null,
          inactive: true,
        };
      });
      return Object.assign({}, state, {
        ...state,
        originalData: _.merge(_.cloneDeep(state.originalData), newGoalsObj),
        updatedData: _.merge(_.cloneDeep(state.updatedData), newGoalsObj),
      });
    case SAVE_GOALS:
      return Object.assign({}, state, { pending: true });
    case SAVE_GOALS_SUCCESS:
      let newGoals = _.cloneDeep(state.updatedData);
      return Object.assign({}, state, {
        ...state,
        originalData: newGoals,
        hasChangesToSave: false,
        hasSavedSuccessfully: true,
        pending: false,
      });
    case SAVE_GOALS_ERROR:
      return Object.assign({}, state, {
        ...state,
        error:
          "There was an error in saving your goals! Please try again later.",
        hasSavedSuccessfully: false,
        pending: false,
      });
    default:
      return state;
  }
}
